module.exports = __webpack_public_path__ + "img/9.d8e6f033.jpg";